import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core'

// titulos de columnas
const headCells = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Productos', name: true },
  { id: 'producer', numeric: false, disablePadding: false, label: 'Productor' },
  { id: 'stock', numeric: false, disablePadding: false, label: 'Stock' },
  { id: 'sale_format', numeric: false, disablePadding: false, label: 'Formato de venta' },
  { id: 'wholesale_unit_price', numeric: true, disablePadding: false, label: 'Precio al por mayor' },
  { id: 'price_package', numeric: true, disablePadding: false, label: 'Precio caja' },
  { id: 'offer_price', numeric: true, disablePadding: false, label: 'Precio Oferta' },
  { id: 'isActive', numeric: false, disablePadding: false, label: 'Estado' },
  { id: 'edit', numeric: false, disablePadding: false, label: 'Acciones', edit: true },
]

export const EnhancedTableHead = ({ classes, order, orderBy, onRequestSort }) => {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox"></TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : headCell.name ? 'left' : 'center'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}>
            <b>
              {!['download', 'edit'].includes(headCell.id) ? (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}>
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                  ) : null}
                </TableSortLabel>
              ) : (
                <span aling="right">{headCell.label}</span>
              )}
            </b>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
}
